/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ListFigureUnit = (typeof ListFigureUnit)[keyof typeof ListFigureUnit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListFigureUnit = {
  '%': '%',
  pp: 'pp',
  attempts: 'attempts',
  count: 'count',
} as const;
